import { useState, useEffect } from "react";
import { Phone, CreditCard } from 'lucide-react';
import useApi from '../../../CustomHooks/useApi';
import OtpPopup from './OtpPopup';
import { useSelector } from "react-redux";
import BiometricPopup from "./BiometricPopup";
import { useNavigate } from "react-router-dom";

const Merchantekyc = () => {
  const navigate = useNavigate();
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otpref, setOtpref] = useState(false);
  const [otphash, setOtphash] = useState(false);
  const [outletId, setOutletId] = useState();
  const [mobileNumber, setMobileNumber] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const merchantdetails = useSelector((state) => state.auth?.employeeDetails);
  const userId = useSelector((state) => state.auth?.employeeDetails?.userId);
  const isekyc = useSelector((state) => state.auth?.employeeDetails?.is_ekyc);
  const outletid = useSelector((state) => state.auth?.employeeDetails?.outlet_id);
  const [fullName, setFullName] = useState("");
  const [dob, setDob] = useState("");
  const [addressFull, setAddressFull] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [isCheckingBioStatus, setIsCheckingBioStatus] = useState(false);
  const [bioPopupOpen, setBioPopupOpen] = useState(false);
  const [bioResponses, setBioResponses] = useState({
    wap: null,
    dmi: null
  });

  const [showCheckingPopup, setShowCheckingPopup] = useState(false);
  const [gender, setGender] = useState("");
  const [showBiometricPopup, setShowBiometricPopup] = useState(false);
  const [pidData, setPidData] = useState(null);
  const [bioRefKey, setBioRefKey] = useState("");
  const [bioMerchantId, setBioMerchantId] = useState("");


  // const { callApi: iniciateekyc } = useApi("/aeps/signup/initiate", "POST");
  // const { callApi: verifyotp } = useApi("/aeps/signup/validate", "POST");
  const { callApi: initiateMinKyc } = useApi(
    "/aeps/signup/min-kyc",
    "POST"
  );

  const { callApi: fetchBiometricStatus } = useApi(
    "/aeps/biometric/status",
    "POST"
  );

  const { callApi: submitBiometric } = useApi(
    "/aeps/biometric/submit",
    "POST"
  );

  useEffect(() => {
    getLocation();
  }, []);

  const resetForm = () => {
    setMobileNumber("");
    setAadhaarNumber("");
    setFullName("");
    setDob("");
    setAddressFull("");
    setCity("");
    setPincode("");

    setErrorMessage("");
    setSuccessMessage("");

    setIsLoading(false);

    // biometric-related states
    setIsCheckingBioStatus(false);
    setBioResponses({ wap: null, dmi: null });
  };


  const getLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude;
        const long = position.coords.longitude;
        setLatitude(lat);
        setLongitude(long);
        setErrorMessage("");
      },
        (error) => {
          console.error("Error getting location:", error);
          setErrorMessage("Unable to fetch location. Please enable location services.");
        }
      );
    }
  };

  // const initiateEkyc = async () => {
  //   if (!latitude || !longitude) {
  //     setErrorMessage("Please allow location access to proceed");
  //     return;
  //   }

  //   if (!mobileNumber || !aadhaarNumber) {
  //     setErrorMessage("Please fill all required fields");
  //     return;
  //   }

  //   setIsLoading(true);
  //   try {
  //     const ekycbodydata =
  //     {
  //       mobile: mobileNumber,
  //       email: merchantdetails.email,
  //       aadhaar: aadhaarNumber,
  //       pan: merchantdetails.pan?.toUpperCase(),
  //       bankAccountNo: merchantdetails.bank_account_no,
  //       bankIfsc: merchantdetails.bank_ifsc?.toUpperCase(),
  //       latitude: latitude,
  //       longitude: longitude,
  //       consent: "Y"
  //     }

  //     const response = await iniciateekyc(ekycbodydata, `?userId=${userId}`);
  //     console.log("eKYC response:", response);
  //     if (response?.statuscode === "TXN") {
  //       setShowOtpPopup(true);
  //       setOtphash(response?.data?.hash);
  //       setOtpref(response?.data?.otpReferenceID);
  //     } else {
  //       setErrorMessage(response.status);
  //     }
  //   } catch (error) {
  //     setErrorMessage('An error occurred while initiating eKYC');
  //     console.error('eKYC initiation error:', error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const initiateEkyc = async () => {
  //   if (!latitude || !longitude) {
  //     setErrorMessage("Please allow location access to proceed");
  //     return;
  //   }

  //   if (!gender) {
  //     setErrorMessage("Please select gender");
  //     return;
  //   }

  //   if (!mobileNumber || !aadhaarNumber) {
  //     setErrorMessage("Please fill all required fields");
  //     return;
  //   }

  //   if (!fullName || !dob || !addressFull || !city || !pincode) {
  //     setErrorMessage("Please fill all required details");
  //     return;
  //   }

  //   setIsLoading(true);
  //   setErrorMessage("");
  //   setSuccessMessage("");

  //   try {
  //     const body = {
  //       mobile: mobileNumber,
  //       name: fullName,
  //       gender: gender,
  //       pan: merchantdetails?.pan?.toUpperCase(),
  //       email: merchantdetails?.email,
  //       aadhaar: aadhaarNumber,
  //       dateOfBirth: dob, // YYYY-MM-DD
  //       latitude: latitude.toString(),
  //       longitude: longitude.toString(),
  //       address: {
  //         full: addressFull,
  //         city: city,
  //         pincode: pincode
  //       }
  //     };


  //     const response = await initiateMinKyc(body, `?userId=${userId}`);

  //     console.log("Min KYC response:", response);

  //     if (
  //       response?.statuscode === "TXN" ||
  //       response?.error_code === 202
  //     ) {
  //       setSuccessMessage(
  //         response?.message || "AEPS Min KYC completed successfully"
  //       );
  //       setOutletId(response?.outletId || outletid);

  //       if (
  //         response?.statuscode === "TXN" ||
  //         response?.error_code === 202
  //       ) {
  //         setSuccessMessage(
  //           response?.message || "AEPS Min KYC completed successfully"
  //         );
  //         setOutletId(response?.outletId || outletid);

  //         // ✅ STEP 1: SHOW CHECKING POPUP
  //         setShowCheckingPopup(true);

  //         // ✅ STEP 2: WAIT 5 SECONDS
  //         setTimeout(async () => {
  //           setShowCheckingPopup(false);

  //           // ✅ STEP 3: HIT BIOMETRIC STATUS APIS
  //           await fetchBiometricStatuses();

  //           // ✅ STEP 4: SHOW RESULT POPUP
  //           setBioPopupOpen(true);
  //         }, 5000);

  //         return;
  //       }

  //     }

  //     else {
  //       setErrorMessage(
  //         response?.message || response?.status || "Min KYC failed"
  //       );
  //     }
  //   } catch (err) {
  //     console.error("Min KYC error:", err);
  //     setErrorMessage(
  //       err?.response?.data?.message ||
  //       "An error occurred while completing Min KYC"
  //     );
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const initiateEkyc = async () => {
    if (!latitude || !longitude) {
      setErrorMessage("Please allow location access to proceed");
      return;
    }

    if (!gender) {
      setErrorMessage("Please select gender");
      return;
    }

    if (!mobileNumber || !aadhaarNumber) {
      setErrorMessage("Please fill all required fields");
      return;
    }

    if (!fullName || !dob || !addressFull || !city || !pincode) {
      setErrorMessage("Please fill all required details");
      return;
    }

    setIsLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const body = {
        mobile: mobileNumber,
        name: fullName,
        gender: gender, // ✅ FIXED
        pan: merchantdetails?.pan?.toUpperCase(),
        email: merchantdetails?.email,
        aadhaar: aadhaarNumber,
        dateOfBirth: dob,
        latitude: latitude.toString(),
        longitude: longitude.toString(),
        address: {
          full: addressFull,
          city: city,
          pincode: pincode
        }
      };

      const response = await initiateMinKyc(body, `?userId=${userId}`);
      console.log("Min KYC response:", response);

      // 🔴 CASE 1: BIOMETRIC REQUIRED
      if (response?.action === "ACTION-REQUIRED") {
        setBioRefKey(response.referenceKey);
        setBioMerchantId(response.merchantId);
        setOutletId(response.outletId);

        setSuccessMessage("Biometric authentication required");
        setShowBiometricPopup(true);
        return;
      }

      // 🟢 CASE 2: SUCCESS (NO BIOMETRIC)
      // if (
      //   response?.statuscode === "TXN" ||
      //   response?.error_code === 202
      // ) {
      //   setSuccessMessage(
      //     response?.message || "AEPS Min KYC completed successfully"
      //   );
      //   setOutletId(response?.outletId || outletid);
      //   return;
      // }
      if (
        response?.statuscode === "TXN" ||
        response?.error_code === 202
      ) {
        setSuccessMessage(
          response?.message || "AEPS Min KYC completed successfully"
        );
        setOutletId(response?.outletId || outletid);

        // ✅ STEP 1: Show checking popup
        setShowCheckingPopup(true);

        // ✅ STEP 2: Wait 5 seconds → hit biometric status
        setTimeout(async () => {
          setShowCheckingPopup(false);

          await fetchBiometricStatuses();   // 🔥 THIS WAS MISSING

          setBioPopupOpen(true);
        }, 2000);

        return;
      }

      // ❌ CASE 3: FAILURE
      setErrorMessage(
        response?.message || response?.status || "Min KYC failed"
      );

    } catch (err) {
      console.error("Min KYC error:", err);
      setErrorMessage(
        err?.response?.data?.message ||
        "An error occurred while completing Min KYC"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const submitBiometricData = async (pidPayload) => {
    try {
      setIsLoading(true);

      const body = {
        merchantId: bioMerchantId,
        referenceKey: bioRefKey,
        latitude: latitude.toString(),
        longitude: longitude.toString(),
        externalRef: `BIO${Date.now()}`,
        captureType: "",
        biometricData: pidPayload
      };

      const res = await submitBiometric(body);

      if (res?.statuscode === "TXN") {
        setSuccessMessage("Biometric authentication successful");
        setShowBiometricPopup(false);
      } else {
        setErrorMessage(res?.message || "Biometric authentication failed");
      }
    } catch (err) {
      setErrorMessage(
        err?.response?.data?.message || "Biometric submission failed"
      );
    } finally {
      setIsLoading(false);
    }
  };



  // const fetchBiometricStatuses = async () => {
  //   try {
  //     const wapRes = await fetchBiometricStatus({
  //       merchantId: merchantdetails?.username,
  //       serviceType: "WAP"
  //     });

  //     const dmiRes = await fetchBiometricStatus({
  //       merchantId: merchantdetails?.username,
  //       serviceType: "DMI"
  //     });

  //     setBioResponses({ wap: wapRes, dmi: dmiRes });

  //   } catch (err) {
  //     setBioResponses({
  //       wap: { message: "Failed to fetch AEPS status" },
  //       dmi: { message: "Failed to fetch DMT status" }
  //     });
  //   }
  // };


  const fetchBiometricStatuses = async () => {
    try {
      const wapRes = await fetchBiometricStatus({
        merchantId: merchantdetails?.username,
        serviceType: "WAP"
      });

      const dmiRes = await fetchBiometricStatus({
        merchantId: merchantdetails?.username,
        serviceType: "DMI"
      });

      setBioResponses({
        wap: {
          action: wapRes?.action,
          status: wapRes?.status,
          kycStatus: wapRes?.kycStatus
        },
        dmi: {
          action: dmiRes?.action,
          status: dmiRes?.status,
          kycStatus: dmiRes?.kycStatus
        }
      });

    } catch (err) {
      setBioResponses({
        wap: { action: "FAILED" },
        dmi: { action: "FAILED" }
      });
    }
  };





  // const verifyOtp = async (otp) => {
  //   setIsLoading(true);
  //   try {
  //     const otpbody = {
  //       otp: otp,
  //       otpReferenceID: otpref,
  //       hash: otphash

  //     }
  //     const response = await verifyotp(otpbody, `?userId=${userId}`);
  //     console.log("OTP verification response:", response);
  //     if (response?.statuscode === "TXN") {
  //       setShowOtpPopup(false);
  //       setSuccessMessage(response.status);
  //       setOutletId(response?.data?.outletId);
  //       setErrorMessage("");
  //     } else {
  //       setErrorMessage(response.status);
  //       setSuccessMessage("");
  //       setShowOtpPopup(false);
  //     }
  //   } catch (error) {
  //     alert('An error occurred during OTP verification');
  //     console.error('OTP verification error:', error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // return (
  //   <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 animate-fadeIn">
  //     <div className="max-w-4xl mx-auto px-4">
  //       {/* Header */}
  //       <div className="text-center mb-8">
  //         <h1 className="text-3xl font-bold text-gray-800 mb-3">Merchant eKYC</h1>
  //         <div className="w-24 h-1.5 bg-gradient-to-r from-orange-400 to-orange-600 mx-auto rounded-full mb-4"></div>
  //         <p className="text-md text-gray-600 max-w-lg mx-auto">
  //           Complete your KYC verification
  //         </p>
  //       </div>

  //       {/* Main Content Card */}
  //       <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
  //         {!isekyc && (
  //           <div className="space-y-6 max-w-lg mx-auto">

  //             {/* PAN Number */}
  //             <div className="relative">
  //               <label className="block text-sm font-medium text-gray-700 mb-2">
  //                 <CreditCard className="inline-block w-4 h-4 mr-2 text-orange-500" />
  //                 PAN Number
  //               </label>              <input
  //                 type="text"
  //                 disabled
  //                 value={merchantdetails?.pan ? `${"*".repeat(6)}${merchantdetails.pan.slice(-4)}` : ""}
  //                 className="w-full p-3 bg-gray-50 border border-gray-200 rounded-lg 
  //                 text-gray-500 focus:ring-0 disabled:cursor-not-allowed"
  //               />
  //             </div>

  //             {/* Mobile Number */}
  //             <div className="relative">
  //               <label className="block text-sm font-medium text-gray-700 mb-2">
  //                 <Phone className="inline-block w-4 h-4 mr-2 text-orange-500" />
  //                 Mobile Number*
  //               </label>
  //               <input
  //                 type="text"
  //                 value={mobileNumber}
  //                 maxLength={10}
  //                 onChange={(e) => {
  //                   const val = e.target.value;
  //                   if (/^\d*$/.test(val)) {
  //                     setMobileNumber(val);
  //                   }
  //                 }}
  //                 className="w-full p-3 bg-white border border-gray-200 rounded-lg 
  //                 text-gray-800 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
  //                 placeholder="Enter mobile number"
  //               />
  //             </div>

  //             {/* Aadhaar Number */}
  //             <div className="relative">
  //               <label className="block text-sm font-medium text-gray-700 mb-2">
  //                 <CreditCard className="inline-block w-4 h-4 mr-2 text-orange-500" />
  //                 Aadhaar Number*
  //               </label>
  //               <input
  //                 type="text"
  //                 value={aadhaarNumber}
  //                 maxLength={12}
  //                 onChange={(e) => {
  //                   const val = e.target.value;
  //                   if (/^\d{0,12}$/.test(val)) {
  //                     setAadhaarNumber(val);
  //                   }
  //                 }}
  //                 className="w-full p-3 bg-white border border-gray-200 rounded-lg 
  //                 text-gray-800 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
  //                 placeholder="Enter Aadhaar number"
  //               />
  //             </div>
  //           </div>
  //         )}


  //         <div className="mt-4">
  //           {errorMessage && (
  //             <p className="text-red-500 text-center font-medium">{errorMessage}</p>
  //           )}
  //           {successMessage && (
  //             <p className="text-green-500 text-center font-medium bg-green-50 p-3 rounded-lg border border-green-200">
  //               ✓ {successMessage}
  //             </p>
  //           )}
  //         </div>

  //         <div className="mt-6 flex justify-center">
  //           {outletId || isekyc ? (
  //             <div className="flex items-center">
  //               <div className="bg-green-50 border border-green-200 rounded-lg px-4 py-2 flex items-center">
  //                 <span className="text-green-500 text-lg mr-2">✓</span>
  //                 <div>
  //                   <p className="text-green-700 font-medium">KYC Verified</p>
  //                   <p className="text-green-600 text-sm">Outlet ID: {outletId || outletid}</p>
  //                 </div>
  //               </div>
  //             </div>
  //           ) : (
  //             <button
  //               onClick={initiateEkyc}
  //               className={`px-6 py-3 ${isLoading ? 'bg-orange-300 cursor-not-allowed' : 'bg-gradient-to-r from-orange-500 to-orange-600'
  //                 } text-white font-semibold rounded-xl 
  // hover:from-orange-600 hover:to-orange-700 
  // focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 
  // transition-all duration-300 transform hover:scale-105 active:scale-95`}
  //             >
  //               {isLoading ? (
  //                 <svg className="animate-spin h-5 w-5 mx-auto text-white" viewBox="0 0 24 24">
  //                   <circle className="opacity-25" cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="4" />
  //                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
  //                 </svg>
  //               ) : (
  //                 <span>Initiate eKYC</span>
  //               )}
  //             </button>
  //           )}
  //         </div>
  //       </div>

  //       {/* OTP Popup */}
  //       {showOtpPopup && (
  //         <OtpPopup
  //           onClose={() => setShowOtpPopup(false)}
  //           onVerify={verifyOtp}
  //           isLoading={isLoading}
  //         />
  //       )}
  //     </div>
  //   </div>
  // );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10">
      <div className="max-w-5xl mx-auto px-4">

        {/* HEADER */}
        <div className="mb-10 text-center">
          <h1 className="text-3xl font-semibold text-slate-900">
            Merchant eKYC Verification
          </h1>
          <p className="mt-2 text-slate-600 max-w-xl mx-auto">
            Complete your Aadhaar-based verification to activate AEPS and other
            merchant services.
          </p>
        </div>

        {/* MAIN CARD */}
        <div className="bg-white/90 backdrop-blur-xl rounded-3xl
                      shadow-[0_40px_90px_-25px_rgba(0,0,0,0.4)]
                      border border-slate-200 p-10">

          {/* {!isekyc && ( */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

            {/* LEFT INFO */}
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-slate-900">
                  Merchant Details
                </h3>
                <p className="text-sm text-slate-500 mt-1">
                  These details are fetched from your profile
                </p>
              </div>

              <div className="space-y-4">
                <div className="p-4 rounded-xl bg-slate-50 border border-slate-200">
                  <p className="text-xs text-slate-500 mb-1">PAN Number</p>
                  <p className="font-medium text-slate-700 tracking-wider">
                    {merchantdetails?.pan
                      ? `${"*".repeat(6)}${merchantdetails.pan.slice(-4)}`
                      : "-"}
                  </p>
                </div>

                <div className="p-4 rounded-xl bg-slate-50 border border-slate-200">
                  <p className="text-xs text-slate-500 mb-1">Registered Email</p>
                  <p className="font-medium text-slate-700">
                    {merchantdetails?.email || "-"}
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-semibold text-slate-900">
                  Aadhaar Verification
                </h3>
                <p className="text-sm text-slate-500 mt-1">
                  OTP will be sent for consent-based verification
                </p>
              </div>

              <div className="space-y-4">
                <input
                  type="text"
                  value={mobileNumber}
                  maxLength={10}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) setMobileNumber(val);
                  }}
                  placeholder="Mobile Number"
                  className="w-full px-4 py-3 rounded-xl
                             border border-slate-300
                             focus:border-indigo-600 focus:outline-none"
                />

                <input
                  type="text"
                  value={aadhaarNumber}
                  maxLength={12}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d{0,12}$/.test(val)) setAadhaarNumber(val);
                  }}
                  placeholder="Aadhaar Number"
                  className="w-full px-4 py-3 rounded-xl
                             border border-slate-300
                             focus:border-indigo-600 focus:outline-none"
                />

                <input
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  placeholder="Full Name (as per Aadhaar)"
                  className="w-full px-4 py-3 rounded-xl border border-slate-300"
                />

                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border border-slate-300"
                >
                  <option value="">Select Gender</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                  <option value="T">Transgender</option>
                </select>

                <input
                  type="date"
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border border-slate-300"
                />

                <input
                  type="text"
                  value={addressFull}
                  onChange={(e) => setAddressFull(e.target.value)}
                  placeholder="Full Address"
                  className="w-full px-4 py-3 rounded-xl border border-slate-300"
                />

                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    placeholder="City"
                    className="px-4 py-3 rounded-xl border border-slate-300"
                  />

                  <input
                    type="text"
                    value={pincode}
                    maxLength={6}
                    onChange={(e) => setPincode(e.target.value.replace(/\D/g, ""))}
                    placeholder="Pincode"
                    className="px-4 py-3 rounded-xl border border-slate-300"
                  />
                </div>

              </div>
            </div>
          </div>
          {/* )} */}

          {/* STATUS MESSAGES */}
          <div className="mt-6">
            {errorMessage && (
              <div className="bg-red-50 border border-red-200
                            text-red-700 rounded-xl px-4 py-3 text-sm">
                {errorMessage}
              </div>
            )}

            {successMessage && (
              <div className="bg-emerald-50 border border-emerald-200
                            text-emerald-700 rounded-xl px-4 py-3 text-sm">
                ✓ {successMessage}
              </div>
            )}
          </div>

          {/* ACTION */}
          {/* <div className="mt-8 flex justify-center">
          {outletId || isekyc ? (
            <div className="flex items-center gap-4
                            bg-emerald-50 border border-emerald-200
                            rounded-2xl px-6 py-4">
              <div className="w-10 h-10 rounded-full
                              bg-emerald-600 text-white
                              flex items-center justify-center">
                ✓
              </div>
              <div>
                <p className="font-semibold text-emerald-700">
                  KYC Completed
                </p>
                <p className="text-sm text-emerald-600">
                  Outlet ID: {outletId || outletid}
                </p>
              </div>
            </div>
          ) : (
            <button
              onClick={initiateEkyc}
              disabled={isLoading}
              className="px-8 py-3 rounded-xl
                         bg-gradient-to-r from-indigo-600 to-cyan-500
                         text-white font-semibold
                         shadow-lg hover:shadow-xl
                         disabled:opacity-60
                         transition-all"
            >
              {isLoading ? "Processing..." : "Initiate eKYC"}
            </button>
          )}
        </div> */}
          {/* ACTION */}
          <div className="mt-8 flex flex-col items-center gap-6">

            {/* KYC STATUS (informational only) */}
            {(outletId || isekyc) && (
              <div className="flex items-center gap-4
                    bg-emerald-50 border border-emerald-200
                    rounded-2xl px-6 py-4">
                <div className="w-10 h-10 rounded-full
                      bg-emerald-600 text-white
                      flex items-center justify-center">
                  ✓
                </div>
                <div>
                  <p className="font-semibold text-emerald-700">
                    Onboarding Completed
                  </p>
                  <p className="text-sm text-emerald-600">
                    Outlet ID: {outletId || outletid}
                  </p>
                </div>
              </div>
            )}

            {/* BUTTON – ALWAYS SHOWN */}
            <button
              onClick={initiateEkyc}
              disabled={isLoading}
              className={`px-8 py-3 rounded-xl
      font-semibold text-white
      transition-all shadow-lg hover:shadow-xl
      ${isekyc
                  ? "bg-gradient-to-r from-slate-600 to-slate-700"
                  : "bg-gradient-to-r from-indigo-600 to-cyan-500"}
      disabled:opacity-60`}
            >
              {isLoading
                ? "Processing..."
                : isekyc
                  ? "Re-Initiate eKYC"
                  : "Initiate eKYC"}
            </button>

          </div>

        </div>

        {/* OTP POPUP */}
        {/* {showOtpPopup && (
        <OtpPopup
          onClose={() => setShowOtpPopup(false)}
          onVerify={verifyOtp}
          isLoading={isLoading}
        />
      )} */}
      </div>
      {bioPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-lg shadow-lg">

            <h3 className="text-lg font-semibold mb-4 text-center">
              Biometric Service Status
            </h3>

            {/* WAP */}
            <div className="mb-4 p-3 rounded-lg bg-slate-50 border">
              <p className="font-medium text-slate-700">AEPS Status</p>
              {/* <pre className="text-xs mt-2 text-slate-600 whitespace-pre-wrap">
                {JSON.stringify(bioResponses.wap, null, 2)}
              </pre> */}
              {bioPopupOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
                  <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg text-center">

                    <h3 className="text-lg font-semibold mb-4">
                      Biometric Status
                    </h3>

                    {/* WAP STATUS */}
                    <div className="mb-3 p-3 rounded-lg bg-slate-50 border">
                      <p className="text-sm text-slate-500">AEPS (WAP)</p>
                      <p className="text-lg font-semibold text-slate-800">
                        {bioResponses?.wap?.status || "-"}
                      </p>
                    </div>

                    {/* DMI STATUS */}
                    <div className="mb-4 p-3 rounded-lg bg-slate-50 border">
                      <p className="text-sm text-slate-500">DMT (DMI)</p>
                      <p className="text-lg font-semibold text-slate-800">
                        {bioResponses?.dmi?.status || "-"}
                      </p>
                    </div>

                    {bioResponses?.wap?.action === "NO-ACTION-REQUIRED" ? (
                      <div className="mb-5 text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-2">
                        Now you can proceed with AEPS
                      </div>
                    ) : (
                      <div className="mb-5 text-sm text-orange-700 bg-orange-50 border border-orange-200 rounded-lg px-3 py-2">
                        Please go to AEPS, select Bank 2 and complete your biometric eKYC
                      </div>
                    )}

                    <button
                      onClick={() => {
                        setBioPopupOpen(false);
                        resetForm();
                        navigate("/aeps");
                      }}
                      className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg"
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* DMI */}
            <div className="mb-4 p-3 rounded-lg bg-slate-50 border">
              <p className="font-medium text-slate-700">DMT Status</p>
              <pre className="text-xs mt-2 text-slate-600 whitespace-pre-wrap">
                {JSON.stringify(bioResponses.dmi, null, 2)}
              </pre>
            </div>

            <button
              // onClick={() => setBioPopupOpen(false)}
              onClick={() => {
                setBioPopupOpen(false);
                resetForm();
                navigate("/retailerdashboard");
              }}
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {isCheckingBioStatus && (
        <div className="mt-4 bg-blue-50 border border-blue-200
                  text-blue-700 rounded-xl px-4 py-3 text-sm
                  flex items-center gap-3">
          <svg
            className="animate-spin h-4 w-4 text-blue-600"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" className="opacity-25" />
            <path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="4" className="opacity-75" />
          </svg>

          <span>
            Your KYC status is being checked. Please wait…
          </span>
        </div>
      )}

      {showCheckingPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg text-center">
            <svg
              className="animate-spin h-8 w-8 mx-auto text-indigo-600 mb-4"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" className="opacity-25" />
              <path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="4" className="opacity-75" />
            </svg>

            <h3 className="text-lg font-semibold text-slate-800">
              Checking eKYC Status
            </h3>

            <p className="text-sm text-slate-600 mt-2">
              Please wait while we verify your biometric eligibility.
            </p>
          </div>
        </div>
      )}

      {showBiometricPopup && (
        <BiometricPopup
          setPidData={(data) => {
            setPidData(data);
            submitBiometricData(data);
          }}
          setErrorMessage={setErrorMessage}
          setSuccessMessage={setSuccessMessage}
        />
      )}


    </div>
  );


};

export default Merchantekyc;